module.exports = __webpack_public_path__ + "img/373T3YQLNGHpSqNniklV-B.a59f5794.svg";